﻿import { Injectable, Inject } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { APP_BRAND } from '@app/common/services/config.service';
import {HttpParams} from "@angular/common/http";
import { LocalStorageService } from 'angular-2-local-storage';

@Injectable({ providedIn: 'root' })
export class LoginService {

  constructor(
    @Inject(APP_BRAND) private APP_BRAND: any,
    private stateService: StateService,
    private localStorageService: LocalStorageService,
  ) {
  }

  redirectToLogin(includeParams = false, loggedOut = false) {
    if (includeParams) {
      const redirectUrl = window.location.hash.split("#!")[1];
      const code = new URLSearchParams(window.location.search).get('code');
      const state = new URLSearchParams(window.location.search).get('state');
      // Přesměrování po SSO přihlášení
      if (this.APP_BRAND.LOGIN.SSO && redirectUrl === undefined && code) {
        const queryParams = new HttpParams()
          .set('code', code)
          .set('state', state)
          .toString();
        window.location.href = window.location.protocol + '//' + window.location.host + window.location.pathname + '#!/login?' + queryParams;
        return;
      }
      const params = {
        redirectUrl: redirectUrl === '/otherwise' ? undefined : redirectUrl,
      }
      return this.stateService.go('login', params);
    } else if (loggedOut && this.APP_BRAND.LOGIN && this.APP_BRAND.LOGIN.LOGOUT_URL) {
      // přesměrování v závislosti na host a referrer má přednost
      if (this.APP_BRAND.LOGIN.SSO_OPTIONS && this.APP_BRAND.LOGIN.SSO_OPTIONS.HOSTS) {
        const domainConfig = this.APP_BRAND.LOGIN.SSO_OPTIONS.HOSTS[window.location.host];
        const referrer:string = this.localStorageService.get('auth-referrer');

        if (domainConfig && domainConfig.REFERRER && referrer && domainConfig.REFERRER[referrer] && domainConfig.REFERRER[referrer].logoutUrl) {
          window.location.href = domainConfig.REFERRER[referrer].logoutUrl;
          return;
        }
      }
      window.location.href = this.APP_BRAND.LOGIN.LOGOUT_URL;
      return;
    } else {
      return this.stateService.go('login', { loggedOut: loggedOut });
    }
  }
}
